import { useEffect } from 'react';

export const NaverRegisterStartPage = () => {
  useEffect(() => {
    //커머스 솔루션 가입 페이지로 전환
    //리다이렉션을 위한 페이지 입니다.
    //아래 링크로 리다이렉션이 진행되면 다시 네이버 쪽에서 NaverRegisterToken 스크린으로 리다이렉션 시켜줍니다.

    window.open(
      'https://sell.smartstore.naver.com/#/member/auth?interlockType=solution_auth&returnUrl=https://solution.smartstore.naver.com/ko/oauth/redirect?solutionId=10XxRcUYSy4N7fiZ5BYNMh',
      '_self',
    );
  }, []);

  return <></>;
};
